import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import "./Slider.css";

export type SliderProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

/**
 * A range slider. Give it an aria-label. For two handles on one track, put two
 * Sliders in one box and set `position: absolute; pointer-events: none` on
 * both through `className` (the thumbs stay clickable).
 * Example: <Slider min={0} max={100} value={v} onChange={e => setV(+e.target.value)} aria-label="Budget" />
 */
const Slider = forwardRef<HTMLInputElement, SliderProps>(
  ({ className = "", ...rest }, ref) => (
    <input
      ref={ref}
      type="range"
      className={`ds-slider ${className}`.trim()}
      {...rest}
    />
  )
);

Slider.displayName = "Slider";

export default Slider;
